export default __webpack_public_path__ + "static/media/ocean-elements.ee4a2dc7.jpg";